import { isDefined } from "@clipboard-health/util-ts";
import type { RadarUser } from "capacitor-radar";

import { type GeoLocation, type LegacyGeoLocationCoordinates } from "./types";

export function convertToGeoLocation(
  legacyGeoLocationCoordinates: LegacyGeoLocationCoordinates
): GeoLocation {
  const [longitude, latitude] = legacyGeoLocationCoordinates;
  return { longitude, latitude };
}

/**
 * @deprecated
 * The legacy APIs and code patterns assume that coordinates are well understood
 * to be in a specific order of longitude, latitude.
 * This is not a good practice, and can easily lead to mistakes.
 * Use the object `GeoLocation` instead.
 * Do not use array coordinates for geoLocation. Use `GeoLocation` instead.
 */
export function convertToLegacyGeoLocationCoordinates(
  geoLocation: GeoLocation
): LegacyGeoLocationCoordinates {
  const { longitude, latitude } = geoLocation;
  return [longitude, latitude];
}

/**
 * @deprecated
 * The legacy APIs and code patterns assume that coordinates are well understood
 * to be in a specific order of latitude, longitude.
 * This is not a good practice, and can easily lead to mistakes.
 * Use the object `GeoLocation` instead.
 */
export function formatGeoLocationToLatitudeLongitude(geoLocation: GeoLocation): string {
  const { longitude, latitude } = geoLocation;
  return `${latitude},${longitude}`;
}

export function convertToGoogleMapsLocation(geoLocation: GeoLocation): google.maps.LatLngLiteral {
  return {
    lat: geoLocation.latitude,
    lng: geoLocation.longitude,
  };
}

export function convertFromGoogleMapsLocation(
  googleMapsLocation: google.maps.LatLngLiteral
): GeoLocation {
  return {
    latitude: googleMapsLocation.lat,
    longitude: googleMapsLocation.lng,
  };
}

interface WithinFacilityGeofenceProps {
  facilityId?: string;
  user?: RadarUser;
}

export function isWithinFacilityGeofence(params: WithinFacilityGeofenceProps) {
  const { facilityId, user } = params;
  if (!isDefined(facilityId)) {
    return false;
  }

  const geofences = user?.geofences ?? [];
  return geofences.some((geofence) => geofence?.externalId === facilityId);
}
